export default () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 195 189.6"
    xmlSpace="preserve"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#FFFFFF"
      d="M107,94.2c-3.8,5.4-11.3,6.7-16.7,2.9l-0.5-0.4
	C84.3,92.9,83,85.4,86.8,80l52.9-74.9c3.8-5.4,11.3-6.7,16.7-2.9l0.5,0.4c5.4,3.8,6.7,11.3,2.9,16.7L107,94.2z"
    />
    <path
      fill="#FFFFFF"
      d="M80.3,76.3c-2.7,4.1-3.7,9-2.9,13.9c0.9,5.1,3.7,9.6,8,12.6l0.5,0.4c3.3,2.3,7.2,3.6,11.2,3.6
	c6.3,0,12.3-3.1,15.9-8.3l15.7-22.2c0,0,52.2,0,52.2,0c6.6,0,14,5.4,14,12v13.5c0,6.6-7.4,12-14,12l-12,75.8H24l-12-75.8
	c-6.6,0-12-5.4-12-12V88.3c0-6.6,5.4-12,12-12C12,76.3,80.3,76.3,80.3,76.3z M54.3,129.7c0-3.1-2.5-5.6-5.6-5.6h-0.3
	c-3.1,0-5.6,2.5-5.6,5.6v39.5c0,3.1,2.5,5.6,5.6,5.6h0.3c3.1,0,5.6-2.5,5.6-5.6V129.7z M78.2,129.7c0-3.1-2.5-5.6-5.6-5.6h-0.3
	c-3.1,0-5.6,2.5-5.6,5.6v39.5c0,3.1,2.5,5.6,5.6,5.6h0.3c3.1,0,5.6-2.5,5.6-5.6V129.7z M102.1,129.7c0-3.1-2.5-5.6-5.6-5.6h-0.3
	c-3.1,0-5.6,2.5-5.6,5.6v39.5c0,3.1,2.5,5.6,5.6,5.6h0.3c3.1,0,5.6-2.5,5.6-5.6V129.7z M125.9,129.7c0-3.1-2.5-5.6-5.6-5.6h-0.3
	c-3.1,0-5.6,2.5-5.6,5.6v39.5c0,3.1,2.5,5.6,5.6,5.6h0.3c3.1,0,5.6-2.5,5.6-5.6V129.7z M149.8,129.7c0-3.1-2.5-5.6-5.6-5.6h-0.3
	c-3.1,0-5.6,2.5-5.6,5.6v39.5c0,3.1,2.5,5.6,5.6,5.6h0.3c3.1,0,5.6-2.5,5.6-5.6V129.7z"
    />
  </svg>
);
